import { render, staticRenderFns } from "./MultipleChecklist.vue?vue&type=template&id=62a4cd80"
import script from "./MultipleChecklist.vue?vue&type=script&lang=js"
export * from "./MultipleChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports